import { RushCelebrationContent, RushCelebrationWrapper } from './styles';
import {
  CelebrationInfoAtom,
  showCelebrationAtom,
} from '@/components/features/casino/game-celebration/state';
import { useAtom } from 'jotai';
import { useTheme } from '@mui/material/styles';
import { GradientTypography } from '@/components/ui/Lottie/WinCelebration/styles';
import { Box } from '@mui/material';
import dynamic from 'next/dynamic';
import { Typography } from '@mui/material';
import { useEffect } from 'react';

const Bg = dynamic(() => import('./CelebrationBgAnimation'), {
  ssr: false,
});
const Content = ({ winAmount, rewardType, winner }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <GradientTypography
        as="h1"
        sx={{
          fontSize: '28px',
          fontWeight: '900',
          lineHeight: 1,
          margin: 0,
          [theme.breakpoints.down('md')]: {
            fontSize: '24px',
          },
        }}
      >
        {winner} WIN!
      </GradientTypography>
      <GradientTypography
        as="h1"
        sx={{
          fontSize: '36px',
          fontWeight: '900',
          lineHeight: 1,
          margin: 0,
          [theme.breakpoints.down('md')]: {
            fontSize: '30px',
          },
        }}
      >
        {rewardType?.toUpperCase()}
      </GradientTypography>
      <Typography
        sx={{
          fontSize: '24px',
          margin: 0,
          fontWeight: '900',
          [theme.breakpoints.down('md')]: {
            fontSize: '20px',
          },
        }}
      >
        {winAmount && winAmount}
      </Typography>
    </Box>
  );
};

const ANIMATION_DURATION = 3500;
export default function RushCelebration() {
  const [showWinCelebration, setShowWinCelebration] =
    useAtom(showCelebrationAtom);
  const [celebrationInfo, setCelebrationInfo] = useAtom(CelebrationInfoAtom);
  // const celebrationInfo = {
  //   profit: '100 USDT',
  //   rewardValue: 'Grand Prize',
  // };
  const resetAnimation = () => {
    setShowWinCelebration(false);
    setCelebrationInfo((info) => ({
      ...info,
      multiplier: 0,
      profit: '0',
    }));
  };
  useEffect(() => {
    if (showWinCelebration) {
      setTimeout(() => {
        resetAnimation();
      }, ANIMATION_DURATION);
    }
  }, [showWinCelebration]);
  if (!showWinCelebration) return null;
  return (
    <RushCelebrationWrapper className={'rush-animation-wrapper'}>
      <RushCelebrationContent>
        <Bg></Bg>
        <Content
          winAmount={celebrationInfo.profit}
          rewardType={'Jackpot'}
          winner={celebrationInfo.winner}
        />
      </RushCelebrationContent>
    </RushCelebrationWrapper>
  );
}
